/**
 * Minutos de un ítem de servicio: prioriza event.time (catálogo de tareas).
 */
export const eventMinutes = (serviceEvent) => {
  const fromCatalog = Number(serviceEvent?.event?.time);
  if (Number.isFinite(fromCatalog) && fromCatalog > 0) {
    return fromCatalog;
  }
  const legacy = Number(serviceEvent?.estimatedTime);
  if (Number.isFinite(legacy) && legacy > 0) {
    return legacy;
  }
  return 0;
};

/** Suma minutos totales de un servicio según sus eventos. */
export const sumServiceEventsMinutes = (servicesEvents = []) =>
  servicesEvents.reduce((acc, ev) => acc + eventMinutes(ev), 0);

/**
 * Duración para agenda/calendario (mínimo 30 min por turno).
 */
export const normalizeDurationMinutes = (estimatedTime, serviceEvents = []) => {
  const fromEvents = sumServiceEventsMinutes(serviceEvents);
  if (fromEvents > 0) {
    return Math.max(30, fromEvents);
  }
  const minutes = Number(estimatedTime) || 0;
  if (minutes > 0) {
    return Math.max(30, minutes);
  }
  return 30;
};

export const formatDurationLabel = (totalMinutes) => {
  const mins = Number(totalMinutes) || 0;
  if (!mins) return '—';
  const hours = Math.floor(mins / 60);
  const rem = mins % 60;
  return `${hours}:${String(rem).padStart(2, '0')} h`;
};

/** Formato editable hh:mm (ej. 01:30). */
export const formatDurationHhMm = (totalMinutes) => {
  const mins = Math.max(0, Number(totalMinutes) || 0);
  const hours = Math.floor(mins / 60);
  const rem = mins % 60;
  return `${String(hours).padStart(2, '0')}:${String(rem).padStart(2, '0')}`;
};

/**
 * Parsea "hh:mm" / "h:mm" a minutos totales.
 * Devuelve null si el texto no es válido.
 * Con `strictMinutes`, los minutos deben tener 2 dígitos (01:30).
 */
export const parseDurationHhMm = (value, { strictMinutes = false } = {}) => {
  const raw = String(value || '').trim();
  if (!raw) return null;
  const match = strictMinutes
    ? raw.match(/^(\d{1,3}):([0-5]\d)$/)
    : raw.match(/^(\d{1,3}):([0-5]?\d)$/);
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes) || minutes > 59) {
    return null;
  }
  const total = hours * 60 + minutes;
  return total > 0 ? total : null;
};
